import React, { useCallback } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useLocation } from 'react-router'
import { deleteSearchParams, setManySearchParamValues } from 'lib/url/searchUrlUtils'
import { CruiseSearchFilterKeys } from 'constants/cruise'
import FilterChip from 'components/Luxkit/Chips/FilterChip'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import SolidStarCircleIcon from 'components/Luxkit/Icons/solid/SolidStarCircleIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { replace } from 'connected-react-router'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'

interface Props {
  filters: App.OfferListFilters;
}

function CruiseSearchMobileChipFilters({
  filters,
}: Props) {
  const dispatch = useAppDispatch()
  const { search } = useLocation()
  const { isSpecialOffers, isLuxExclusivePromotion, isLuxPlus } = filters

  const onFilterChange = useCallback((nextFilters: Record<string, any>) => {
    const urlValues = Object.entries(nextFilters)
      .map(([key, value]) => ({ paramName: key, paramValue: value }))
      .filter(({ paramValue }) => !!paramValue)
    let nextSearch = deleteSearchParams(search, ...CruiseSearchFilterKeys)
    nextSearch = setManySearchParamValues(nextSearch, urlValues)
    dispatch(replace({ search: nextSearch }))
  }, [dispatch, search])

  return <CSSBreakpoint max="tablet">
    <Group direction="horizontal" gap={8} verticalAlign="center">
      <FilterChip
        size="medium"
        startIcon={<SolidFireIcon />}
        selected={isSpecialOffers}
        onClick={() => onFilterChange({ ...filters, isSpecialOffers: !isSpecialOffers })}
      >
        Special offers
      </FilterChip>
      <FilterChip
        size="medium"
        startIcon={<SolidStarCircleIcon />}
        selected={isLuxExclusivePromotion}
        onClick={() => onFilterChange({ ...filters, isLuxExclusivePromotion: !isLuxExclusivePromotion })}
      >
        Lux Exclusive
      </FilterChip>
      <FilterChip
        size="medium"
        selected={isLuxPlus}
        onClick={() => onFilterChange({ ...filters, isLuxPlus: !isLuxPlus })}
      >
        <LuxPlusLogoWrapper/>
      </FilterChip>
    </Group>
  </CSSBreakpoint>
}

export default CruiseSearchMobileChipFilters
